// @flow
import { OptionAnswersActionTypes } from './constants';

type OptionAnswersAction = { type: string, payload: {} | string };

// common success
export const optionAnswersApiResponseSuccess = (actionType: string, data: any): OptionAnswersAction => ({
    type: OptionAnswersActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const optionAnswersApiResponseError = (actionType: string, error: string): OptionAnswersAction => ({
    type: OptionAnswersActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getOptionAnswer = (id: string): OptionAnswersAction => ({
    type: OptionAnswersActionTypes.GET_OPTION_ANSWER,
    payload: { id },
});

export const addOptionAnswer = (optionAnswer:any):OptionAnswersAction=>({
    type:OptionAnswersActionTypes.ADD_OPTION_ANSWER,
    payload:optionAnswer
})
export const updateOptionAnswer = (optionAnswer:any):OptionAnswersAction=>({
    type:OptionAnswersActionTypes.UPDATE_OPTION_ANSWER,
    payload:optionAnswer
})
export const deleteOptionAnswer = (id:string):OptionAnswersAction=>({
    type:OptionAnswersActionTypes.DELETE_OPTION_ANSWER,
    payload:{id}
})

export const listOptionAnswers = (params:any): OptionAnswersAction => ({
    type: OptionAnswersActionTypes.LIST_OPTION_ANSWERS,
    payload: params,
});


export const resetOptionAnswers = (): OptionAnswersAction => ({
    type: OptionAnswersActionTypes.RESET,
    payload: {},
});

